"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDialogTitle_unstable", {
    enumerable: true,
    get: ()=>useDialogTitle_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _dialogContext = require("../../contexts/dialogContext");
const _reactIcons = require("@fluentui/react-icons");
const _dialogTrigger = require("../DialogTrigger/DialogTrigger");
const _useDialogTitleStyles = require("./useDialogTitleStyles");
const useDialogTitle_unstable = (props, ref)=>{
    const { as , action  } = props;
    const modalType = (0, _dialogContext.useDialogContext_unstable)((ctx)=>ctx.modalType);
    const internalStyles = (0, _useDialogTitleStyles.useDialogTitleInternalStyles)();
    return {
        components: {
            root: 'h2',
            action: 'div'
        },
        root: (0, _reactUtilities.getNativeElementProps)(as !== null && as !== void 0 ? as : 'h2', {
            ref,
            id: (0, _dialogContext.useDialogContext_unstable)((ctx)=>ctx.dialogTitleId),
            ...props
        }),
        action: (0, _reactUtilities.resolveShorthand)(action, {
            required: modalType === 'non-modal',
            defaultProps: {
                children: /*#__PURE__*/ _react.createElement(_dialogTrigger.DialogTrigger, {
                    disableButtonEnhancement: true,
                    action: "close"
                }, /*#__PURE__*/ _react.createElement("button", {
                    type: "button",
                    className: internalStyles.button,
                    // TODO: find a better way to add internal labels
                    "aria-label": "close"
                }, /*#__PURE__*/ _react.createElement(_reactIcons.Dismiss24Regular, null)))
            }
        })
    };
}; //# sourceMappingURL=useDialogTitle.js.map

//# sourceMappingURL=useDialogTitle.js.map